"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const constants_1 = require("../../../../constants");
const OPERATOR_MAP = {
    MATCHES: "like",
    EQUALS: "=",
    NOT_EQUALS: "!=",
    GREATER_THAN: ">",
    GREATER_THAN_OR_EQUALS: ">=",
    LESS_THAN: "<",
    LESS_THAN_OR_EQUALS: "<=",
    INCLUDED: "in",
    NOT_INCLUDED: "not in",
    EXISTS: "=",
    NOT_EXISTS: "",
    CONTAINS_ALL: "∋",
    CONTAINS_ANY: "any of",
    NOT_CONTAINS: "∌",
    CONTAINS: "∋",
};
const StyledChip = (0, material_1.styled)(material_1.Chip)(({ theme }) => ({
    height: 50,
    // todo [js] replace with signet colors here
    // set to !important to override default MUI styles of grey highlighting
    backgroundColor: "#F5EFEB !important",
    border: `solid 1px #BF9579`,
    borderRadius: 5,
    margin: theme.spacing(1),
}));
const StyledLabel = (0, material_1.styled)(material_1.Typography)(() => ({
    opacity: "1",
}));
const FilterChip = ({ id, active = false, deletable = true, label, value, operator = constants_1.AdvancedSearchOperators.Equals, onDelete = () => { }, }) => (react_1.default.createElement(StyledChip, { clickable: false, sx: active
        ? {
            backgroundColor: "#F5EFEB !important", // signet color stateBackground-selected
        }
        : {}, label: react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledLabel, { display: "block", variant: "caption" }, label),
        react_1.default.createElement(material_1.Typography, { display: "block", variant: "body2" }, `${OPERATOR_MAP[operator]} ${value}`)), onDelete: deletable
        ? () => {
            onDelete(id);
        }
        : undefined, variant: active ? "filled" : "outlined", "data-testid": "filterChip" }));
exports.default = FilterChip;
